
























import {Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { solutionListInstance } from '@/model/SolutionListClass';


type IClause = ISolution.IClause;
interface IForm {
  categoryId: string;
  title: string;
  manDay: number;
}

@Component
export default class ClauseForm extends Vue {
  @Ref() private readonly editCateForm!: FormModel;
  @Prop({required: true}) private clause!: IClause;
  @Prop({default: ''}) private projectId!: string;
  get categorys(): IQuotation.IResponse.ICategoryInfo[] {
    return solutionListInstance.categorys.filter((category) => {
      return category.projects.findIndex((project) => project.id === this.projectId) > -1;
    });
  }
  private form: IForm = {
    categoryId: '',
    title: '',
    manDay: 0,
  };
  private rules = {
    categoryId: [{ required: true, trigger: 'change', message: () => this.$t('form.required')}],
    title: [{ required: true, trigger: 'blur', message: () => this.$t('form.required') }],
    manDay: [{ required: true, trigger: 'blur', message: () => this.$t('form.required') }],
  };
  public validate(): boolean {
    let validateResult: boolean = false;
    this.editCateForm.validate((valid) => {
      validateResult = valid;
      if (valid) {
        // 檢查選擇類型
        validateResult = this.checkCategorys();
        this.syncUpdate();
      } else {
        return false;
      }
    });
    return validateResult;
  }
  @Watch('clause', {immediate: true})
  private watchClause(newValue: IClause) {
    this.form = {...newValue};
  }
  private syncUpdate() {
    this.$emit('update:clause', this.form);
  }
  private checkCategorys() {
    const index = this.categorys.findIndex((category) => category.id === this.form.categoryId);
    if (index < 0) {
      const msg = this.$t('solution.typeNotApplicable').toString();
      this.$message.warning(`'${this.form.title}' ${msg}`);
      return false;
    }
    return true;
  }
}
